import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Page from '@lib/components/v2/Page';
import Modal from '@lib/components/v2/Modal';
import { Form } from 'calidation';
import { localizedString } from '@languages';
import { Error500 } from '../../errors';

import APIs from '../../../services/APIs';

import { MoreInfoContent } from '../../components/Contents';

import anzData from '../../../data/anz-fields.json';

class MoreInfo extends Component {
  constructor(props) {
    super(props);

    this.state = this.getInitialState();

    this.handleChange = this.handleChange.bind(this);
  }

  /**
   * Return the component's initial state
   *
   */
  getInitialState() {
    const state = {
      citizenship: 'Australia',
      occupation: '',
      loading: false,
      fatalError: null,
      errors: {},
      error: null
    };

    return state;
  }

  /**
   * Handle Custom  Field Changes
   * @return
   */
  handleChange = (id, selectedValue) => {
    const { value } = selectedValue;
    this.setState({ [id]: value });
  };

  handleConfirm = () => {
    this.setState({ loading: true });

    const { citizenship, occupation } = this.state;

    const data = {
      citizenship,
      occupation
    };

    APIs.storeMoreInfo(data)
      .then(({ status, msg }) => {
        this.setState({ loading: false });
        if (status !== 'success') {
          this.setState({
            error: {
              issue: msg,
              buttons: [
                {
                  label: localizedString('cancel'),
                  onClick: () => {
                    this.setState({
                      error: null
                    });
                  }
                }
              ]
            }
          });
        }
        this.props.onNextStep();
      })
      .catch(({ message }) => {
        console.error(message);
        const fatalError = {
          component: Error500,
          props: {
            onTryAgain: () => {
              this.props.on500Error();
            }
          }
        };
        this.setState({ fatalError, loading: false });
      });
  };

  render() {
    const { citizenship, occupation, error, loading, fatalError } = this.state;
    const { component: Error, props: errorProps } = fatalError || {};

    const { onExit } = this.props;

    const buttons = [
      { label: localizedString('back'), variant: 'transparent', onClick: onExit },
      {
        label: localizedString('Continue'),
        type: 'submit',
        disabled: !citizenship || !occupation,
        variant: loading ? 'transparent' : 'secandary',
        loading
      }
    ];

    return (
      <div>
        {Error && <Error {...errorProps} />}
        {error && <Modal isOpen {...error} />}
        <Form onSubmit={this.handleConfirm}>
          <Page
            title={localizedString('thisAlsoHelpsVerifyYourIdentity')}
            buttons={buttons}
            onGoBack={this.handleGoBack}
          >
            <MoreInfoContent
              optionsDict={anzData}
              onChange={(id, value) => {
                this.handleChange(id, value);
              }}
            />
          </Page>
        </Form>
      </div>
    );
  }
}

MoreInfo.propTypes = {
  onNextStep: PropTypes.func,
  on500Error: PropTypes.func,
  onExit: PropTypes.func
};

export default connect(mapStateToProps, null)(MoreInfo);

/**
 * Map the store's state to the component's props
 * @param  {Object} state
 * @return {Object}
 */
function mapStateToProps({ appConfig }) {
  return {
    appConfig
  };
}
